import { FC } from 'react';
import { createRoot, Root } from 'react-dom/client';
import videojs from 'video.js';
import Player from 'video.js/dist/types/player';

export type BaseCustomComponentVideo = {
  player: Player;
};

const vjsComponent = videojs.getComponent('Component');

type AddElementProps = {
  player: Player;
  Component: FC<any>;
  props?: { [key: string]: any };
};
class AddElement extends vjsComponent {
  private props?: { [key: string]: any };
  private Component: FC<any>;
  private rootElement: Root;

  constructor({ player, Component, props }: AddElementProps) {
    super(player);

    this.props = props;
    this.Component = Component;

    this.rootElement = createRoot(this.el());

    /* Bind the current class context to the mount method */
    this.mount = this.mount.bind(this);

    /* When player is ready, call method to mount React component */
    player.ready(() => this.mount());
  }

  mount(): void {
    const Component = this.Component;

    this.rootElement.render(
      <>
        <Component vjsComponent={this} {...this.props} player={this.player()} />
      </>
    );
  }
}

type addElementToVideojsProps = {
  player: Player;
  Component: FC<any>;
  props?: { [key: string]: any };
  position?: number;
};
export const addElementToVideojs = ({
  player,
  Component,
  props,
  position,
}: addElementToVideojsProps): void => {
  const element = new AddElement({
    player,
    Component,
    props,
  });

  const parentNode = player.getChild('controlBar');

  if (parentNode) {
    parentNode.addChild(element, {}, position);
  }
};
